var throttle = require('lodash.throttle');

global.responsiveTables = (function ($) {
	'use strict';

	var appendFixedColumn = function ($table) {
		// Extract logic to exclude new "Sök räntor och valuta kurser"
		if ($table.hasClass('sticky-table')) {
			// console.log("sticky-table");
		} else {
			var $fixedColumn = $table.clone().insertBefore($table).addClass('fixed-column').removeClass('main');
			$fixedColumn.attr('aria-hidden', 'true');

			// Only keep first and second cells for each row
			$fixedColumn.find('th:nth-child(n+3), td:nth-child(n+3)').remove();

			if ($table.hasClass('swea-table')) {
				$fixedColumn.find('tr').eq(1).find('th.selection').text('');
				$fixedColumn.find('tr').eq(1).find('th').text('');
			}

			$fixedColumn.find('tr').each(function (i) {
				//Detect if mobile Safari since outerWith and outerHeight is incorrect
				var ua = window.navigator.userAgent;
				var iOS = !!ua.match(/iP(ad|hone)/i);
				var webkit = !!ua.match(/WebKit/i);
				var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

				var calculatedHeight = $table.find('tr:eq(' + i + ') td').outerHeight() ||
					$table.find('tr:eq(' + i + ')').outerHeight();

				if (iOSSafari) {
					calculatedHeight = $table.find('tr:eq(' + i + ') td').height() ||
						$table.find('tr:eq(' + i + ') th').height();
				}

				$(this).height(calculatedHeight);

				if (!$table.hasClass('swea-table')) {
					var calculatedWidth = $table.find('tr:eq(' + i + ') td:nth-child(2)').outerWidth() ||
						$table.find('tr:eq(' + i + ') th:nth-child(2)').outerWidth();

					$fixedColumn.css('maxWidth', calculatedWidth);
				}
			});
		}


	};

	var addPaddingCells = function($table) {
		// Extract logic to exclude new "Sök räntor och valuta kurser"
		if ($table.hasClass('sticky-table')) {
			// console.log("sticky-table");
		} else {
			$table.find('td:first-child').before('<td aria-hidden="true" class="padding-cell"></td>');
			$table.find('td:last-child').after('<td aria-hidden="true" class="padding-cell"></td>');

			if (!$table.hasClass('swea-table')) {
				$table.find('th:first-child').before('<td aria-hidden="true" class="padding-cell"></td>');
				$table.find('th:last-child').after('<td aria-hidden="true" class="padding-cell"></td>');
			}
		}
	};

	var adjustTableForPrint = function($table, i) {
		if (window.matchMedia('print').matches) {
			var tableColumnWidth = 0;
			var colWidth;

			for (i = 0; i < 7; i++) {
				colWidth = $table.find('td:eq(' + i + ')').width();
				tableColumnWidth = tableColumnWidth + colWidth;
			}

			var tableWidth = $table.outerWidth(),
				pageWidth = tableColumnWidth + 50,
				pageCount = Math.ceil(tableWidth / pageWidth),
				printWrap = $('<div></div>').insertAfter($table),
				printPage;

			for (i = 0; i < pageCount; i++) {
				printPage = $('<div></div>').css({
					'overflow': 'hidden',
					'width': pageWidth,
					'page-break-before': i === 0 ? 'auto' : 'always'
				}).appendTo(printWrap);
				$table.clone().removeAttr('id').appendTo(printPage).css({
					'position': 'relative',
					'left': -i * pageWidth
				});
			}
			$table.hide();
		}
	};

	var addScrollFunction = function($table) {
		$table.append('<span class="scroll-icon scroll-icon--right"></span>');
		var $scrollIconRight = $table.find('span.scroll-icon--right');
		var tableViewWidth = Math.floor($table.outerWidth());
		var tableFullWidth = Math.floor($table.find('tbody').outerWidth());
		var tableViewHeight = Math.floor($table.outerHeight());
		var hideScrollIconRight = tableViewHeight <= 300;

		if(hideScrollIconRight) {
			$scrollIconRight.hide();
		} else {
			if (tableViewWidth + 50 > tableFullWidth) {
				$scrollIconRight.hide();
			}

			$scrollIconRight.on('click', function () {
				var leftPos = $table.scrollLeft();
				$table.animate({scrollLeft: leftPos + 100}, 600);
			});

			$table.on('scroll', throttle(function () {
				var hasNotScrolledToEnd = Math.floor(tableFullWidth - tableViewWidth - 10) > $table.scrollLeft();
				$scrollIconRight.toggle(hasNotScrolledToEnd);
				},
			50));

		}

	};

	var addTopMargin = function($table) {
		if (window.innerWidth < 768) {
			var headerHeight = $table.find('.table-header').height();
			$table.css('margin-top', headerHeight + 16 + 'px');
			$table.prev().css('margin-top', headerHeight + 16 + 'px');
		}
	};

	var updateTables = function () {
		var $tables = $('table:not(.js-table-responsive):visible');

		$tables.each(function(i, ele) {
			var $table = $(ele);

			$table.addClass('js-table-responsive');
			$table.wrap('<div class="table-wrapper"></div>');

			addPaddingCells($table);
			addScrollFunction($table);
			appendFixedColumn($table);
			adjustTableForPrint($table, i);
			addTopMargin($table);
			$table.attr( 'tabindex', '0' );

			// Remove border-bottom from row right above summary row
			$table.find('.summary-cell').prev().find('td, th').css('border-bottom', 'none');
		});
	};

	updateTables();

	return {
		updateTables: updateTables
	};
})(jQuery);
